import { h } from 'preact';
import NTLiveHeader from 'components/bolt/header/NTLiveHeader';
import * as BaseComp from 'components/bolt/header/header.js';

export default class Header extends BaseComp.default {
	render(props, state) {
		const baseRender = super.render(props, state);
		const { client, appData} = props;
		const { header, copy } = appData;

		if (header.NTLiveHeader) {
			return <NTLiveHeader
				data={header.NTLiveHeader}
				client={client}
				copy={copy}
				renderExtraActions={this.renderExtraActions}
			/>;
		}

		return baseRender;
	}
}
